import React, { useState,useContext, useEffect } from "react";
import "./Accountpopup.css";
import common from "../config/common.json";
import Accountpay from "./Accountpay";
import { LoadingSpinner } from "../loadingSpinner/LoadingSpinner"
import getGlobalVarContext from "../context/getGlobalVarContext";
import {useIntl} from 'react-intl';


const Accountpopup = ({ plan, coupendata }) => {
  localStorage.setItem("removeProfile",true)
  const [isLoading, setIsLoading] = useState(false);
  const [OpenAccountPopUp, setOpenAccountPopUp] = useState(true);
  const [OpenAccountpay, setOpenAccountpay] = useState(false);
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [line1, setLine1] = useState("");
  const [line2, setLine2] = useState("");
  const [city, setCity] = useState("");
  const [zip, setZip] = useState("");
  const [userid, setUserId] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
    // eslint-disable-next-line no-unused-vars
  const [userError, setUserError] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [userLast, setUserLast] = useState(false);
    // eslint-disable-next-line no-unused-vars
  const [userAddress, setAddress] = useState(false);
    // eslint-disable-next-line no-unused-vars
  const [userAddressline2, setAddressline2] = useState(false);
    // eslint-disable-next-line no-unused-vars
  const [uservalidcity, setvalidcity] = useState(false);
    // eslint-disable-next-line no-unused-vars
  const [userzip, setzip] = useState(false);
    // eslint-disable-next-line no-unused-vars
  const [enterState, setEnterState] = useState(false);
  const [prev_subscription_id, setPrev_subscription_id] = useState(null)
  const [apiError, setApiError] = useState("");
  const [checkRequiredField, setCheckRequiredField] = useState(false);
  const { globalVar,setGlobalVar} = useContext(getGlobalVarContext());
  const {email}= globalVar
  const intl = useIntl()

  function main() {
    setIsLoading(true);
    setCheckRequiredField(true);
    if (
      first_name !== "" &&
      line1 !== "" &&
      last_name !== "" &&
      city !== "" &&
      state !== "" &&
      zip !== "" &&
      country !== ""
    ) {
      getUserData();
    } else {
      setApiError(intl.formatMessage({id: "mustProvideAllDetalis"}));

      setIsLoading(false);
    }
  }

  async function UpdateBillingAddress() {
    var raw = JSON.stringify({
      email: email !==null ?email:localStorage.getItem("email"),
      first_name: first_name,
      last_name: last_name,
      line1: line1,
      city: city,
      state: state,
      zip: zip,
      country: country,
      line2: line2 === "" ? line1:line2,
      purchase_number: "null",
      plan: plan
    });
    var requestOptions = { method: "POST", body: raw };
    var res = await fetch(
      `${common.BASEURL}/user/update/billing/address`,
      requestOptions
    );

    var response = await res.json();
    if (res.status === 404) {
      
      setApiError(response.msg);
      setIsLoading(false);
    } else if (res.status === 200) {
      setOpenAccountPopUp(false);
      setOpenAccountpay(true);
      setIsLoading(false);
    } else {
      setApiError(response.msg);
      setIsLoading(false);
    }
  }
  async function BillingAddress() {
    var raw = JSON.stringify({
      email: email !==null ?email:localStorage.getItem("email"),
      first_name: first_name,
      last_name: last_name,
      line1: line1,
      city: city,
      state: state,
      zip: zip,
      country: country,
      line2: line2 ? line1 :line2,
      purchase_number: "null",
      plan: plan
    });
    var requestOptions = { method: "POST", body: raw };
    var res = await fetch(`${common.BASEURL}/user/data`, requestOptions);
    var response = await res.json();

    if (res.status === 404) {
      setApiError(response.msg);
      setIsLoading(false);
    } else if (res.status === 201) {
      setOpenAccountPopUp(false);
      setOpenAccountpay(true);
      setIsLoading(false);
    } else {
      setApiError(response.msg);
      setIsLoading(false);
    }
  }
 
  async function getUserData() {
    if (userid === "") {
        BillingAddress();
      } else {
        UpdateBillingAddress();
      }
    
  }

  function error(e) {
    let item = e.target.value;
    if (item.length < 3) {
      setUserError(true);
    } else {
      setUserError(false);
    }
  }
  function last(e) {
    let item = e.target.value;
    if (item.length < 3) {
      setUserLast(true);
      setApiError("");
    } else {
      setUserLast(false);
    }
  }
  function line1Address(e) {
    let item = e.target.value;
    if (item.length < 10) {
      setAddress(true);
      setApiError("");
    } else {
      setAddress(false);
    }
  }
 
  function validcity(e) {
    let item = e.target.value;
    if (item.length < 5) {
      setvalidcity(true);
      setApiError("");
    } else {
      setvalidcity(false);
    }
  }
  function validzip(e) {
    let item = e.target.value;
    if (isNaN(item)) {
      setzip(true);
      setApiError("");
    } else {
      setzip(false);
    }
  }
  function usestateadd(e) {
    let item = e.target.value;
    if (isNaN(item)) {
      setEnterState(false);
      setApiError("");
    } else {
      setEnterState(true);
    }
  }
  var requestOptions = {
    method: "GET"
  };
  useEffect(() => {
      setGlobalVar((oldData) => ({
        ...oldData,
        page: false
      }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    fetch(
      `${common.BASEURL}/user/details?email=${email !==null ?email:localStorage.getItem("email")}`,
      requestOptions
    )
      .then(response => response.json())
      .then(result => {
        if (result.msg !== undefined ){

          if(result.msg.first_name !== undefined){
            setFirst_name(result.msg.first_name);
            setLast_name(result.msg.last_name);
            setLine1(result.msg.line1);
            setLine2(result.msg.line2);
            setCity(result.msg.city);
            setZip(result.msg.zip);
            setState(result.msg.state);
            setCountry(result.msg.country)
            setUserId(result.msg.user_id)
            setPrev_subscription_id(result["msg"]["subscription_id"]?result["msg"]["subscription_id"]:null)
          }
          
        }
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        !OpenAccountpay &&
        OpenAccountPopUp && (
          <>
            <div className="accountpopup">
              
              <div className="accountpopup_form">
                <h4>{intl.formatMessage({id: "billingDetailsInfo"})}</h4>
                <div className="center">{apiError}</div>
                
                <div className="accountpopup_splitinput">
                  <div>
                    <label>{intl.formatMessage({id: "lableFristName"})}</label>
                    <input
                      className={
                        checkRequiredField && first_name === ""
                          ? "borderRed"
                          : ""
                      }
                      type="text"
                      value={first_name}
                      autoComplete="off"
                      onChange={e => {
                        setFirst_name(e.target.value);
                        error(e);
                      }}
                      name={intl.formatMessage({id: "lableFristName"})}
                    />
                    
                  </div>
                  <div>
                    <label>{intl.formatMessage({id: "lableLastName"})}</label>
                    <input
                      type="text"
                      className={
                        checkRequiredField && last_name === "" ? "borderRed" : ""
                      }
                      value={last_name}
                      autoComplete="off"
                      onChange={e => {
                        setLast_name(e.target.value);
                        last(e);
                      }}
                      name={intl.formatMessage({id: "lableLastName"})}
                    />
                    
                  </div>
                </div>
                
                <p>{intl.formatMessage({id: "lableAddressLine1"})}</p>
                <input
                  value={line1}
                  className={
                    checkRequiredField && line1 === "" ? "borderRed" : ""
                  }
                  autoComplete="off"
                  onChange={e => {
                    setLine1(e.target.value);
                    line1Address(e);
                  }}
                  name={intl.formatMessage({id: "lableAddressLine1"})}
                  type="text"
                />
                
                <p>{intl.formatMessage({id: "lableAddressLine2"})}<span style={{color:"gray"}}>{intl.formatMessage({id: "lableAddressLine2Optional"})}</span></p>
                <input
                  value={line2}
                  className={
                    checkRequiredField
                  }
                  autoComplete="off"
                  onChange={e => {
                    setLine2(e.target.value);
                    
                  }}
                  name={intl.formatMessage({id: "lableAddressLine2"})}
                  type="text"
                />
                
                
                <div className="accountpopup_splitinput">
                  <div>
                    <label>{intl.formatMessage({id: "lableCity"})}</label>
                    <input
                      value={city}
                      className={
                        checkRequiredField && city === "" ? "borderRed" : ""
                      }
                      autoComplete="off"
                      onChange={e => {
                        setCity(e.target.value);
                        validcity(e);
                      }}
                      name={intl.formatMessage({id: "lableCity"})}
                      type="text"
                    />
                   
                  </div>
                  <div>
                    <label>{intl.formatMessage({id: "lableZip"})}</label>
                    <input
                      value={zip}
                      className={
                        checkRequiredField && zip === "" ? "borderRed" : ""
                      }
                      autoComplete="off"
                      onChange={e => {
                        setZip(e.target.value);
                        validzip(e);
                      }}
                      name={intl.formatMessage({id: "lableZip"})}
                      type="text"
                    />
                   
                  </div>
                </div>
                
                <div className="accountpopup_splitinput">
                  <div>
                    <label>{intl.formatMessage({id: "lableState"})}</label>
                    <input
                      value={state}
                      className={
                        checkRequiredField && state === "" ? "borderRed" : ""
                      }
                      autoComplete="off"
                      onChange={e => {
                        setState(e.target.value);
                        usestateadd(e);
                      }}
                      name={intl.formatMessage({id: "lableState"})}
                      type="text"
                    />
                    
                  </div>
                  
                  <div className="detail_half">
                    <label>{intl.formatMessage({id: "lableCountry"})}</label>
                    <select
                      value={country}
                      onChange={e => {
                        const selectCountry = e.target.value;
                        setCountry(selectCountry);
                      }}
                      id="Select-Country"
                      data-name="Select Country"
                      className="select-field-2 w-select detail_half"
                    >
                      <option>select country</option>
                      <option value="AF">Afghanistan</option>
                      <option value="AX">Aland Islands</option>
                      <option value="AL">Albania</option>
                      <option value="DZ">Algeria</option>
                      <option value="AS">American Samoa</option>
                      <option value="AD">Andorra</option>
                      <option value="AO">Angola</option>
                      <option value="AI">Anguilla</option>
                      <option value="AQ">Antarctica</option>
                      <option value="AG">Antigua and Barbuda</option>
                      <option value="AR">Argentina</option>
                      <option value="AM">Armenia</option>
                      <option value="AW">Aruba</option>
                      <option value="AU">Australia</option>
                      <option value="AT">Austria</option>
                      <option value="AZ">Azerbaijan</option>
                      <option value="BS">Bahamas</option>
                      <option value="BH">Bahrain</option>
                      <option value="BD">Bangladesh</option>
                      <option value="BB">Barbados</option>
                      <option value="BY">Belarus</option>
                      <option value="BE">Belgium</option>
                      <option value="BZ">Belize</option>
                      <option value="BJ">Benin</option>
                      <option value="BM">Bermuda</option>
                      <option value="BT">Bhutan</option>
                      <option value="BO">Bolivia</option>
                      <option value="BQ">
                        Bonaire, Sint Eustatius and Saba
                      </option>
                      <option value="BA">Bosnia and Herzegovina</option>
                      <option value="BW">Botswana</option>
                      <option value="BV">Bouvet Island</option>
                      <option value="BR">Brazil</option>
                      <option value="IO">British Indian Ocean Territory</option>
                      <option value="BN">Brunei Darussalam</option>
                      <option value="BG">Bulgaria</option>
                      <option value="BF">Burkina Faso</option>
                      <option value="BI">Burundi</option>
                      <option value="KH">Cambodia</option>
                      <option value="CM">Cameroon</option>
                      <option value="CA">Canada</option>
                      <option value="CV">Cape Verde</option>
                      <option value="KY">Cayman Islands</option>
                      <option value="CF">Central African Republic</option>
                      <option value="TD">Chad</option>
                      <option value="CL">Chile</option>
                      <option value="CN">China</option>
                      <option value="CX">Christmas Island</option>
                      <option value="CC">Cocos (Keeling) Islands</option>
                      <option value="CO">Colombia</option>
                      <option value="KM">Comoros</option>
                      <option value="CG">Congo</option>
                      <option value="CD">
                        Congo, Democratic Republic of the Congo
                      </option>
                      <option value="CK">Cook Islands</option>
                      <option value="CR">Costa Rica</option>
                      <option value="CI">Cote D'Ivoire</option>
                      <option value="HR">Croatia</option>
                      <option value="CU">Cuba</option>
                      <option value="CW">Curacao</option>
                      <option value="CY">Cyprus</option>
                      <option value="CZ">Czech Republic</option>
                      <option value="DK">Denmark</option>
                      <option value="DJ">Djibouti</option>
                      <option value="DM">Dominica</option>
                      <option value="DO">Dominican Republic</option>
                      <option value="EC">Ecuador</option>
                      <option value="EG">Egypt</option>
                      <option value="SV">El Salvador</option>
                      <option value="GQ">Equatorial Guinea</option>
                      <option value="ER">Eritrea</option>
                      <option value="EE">Estonia</option>
                      <option value="ET">Ethiopia</option>
                      <option value="FK">Falkland Islands (Malvinas)</option>
                      <option value="FO">Faroe Islands</option>
                      <option value="FJ">Fiji</option>
                      <option value="FI">Finland</option>
                      <option value="FR">France</option>
                      <option value="GF">French Guiana</option>
                      <option value="PF">French Polynesia</option>
                      <option value="TF">French Southern Territories</option>
                      <option value="GA">Gabon</option>
                      <option value="GM">Gambia</option>
                      <option value="GE">Georgia</option>
                      <option value="DE">Germany</option>
                      <option value="GH">Ghana</option>
                      <option value="GI">Gibraltar</option>
                      <option value="GR">Greece</option>
                      <option value="GL">Greenland</option>
                      <option value="GD">Grenada</option>
                      <option value="GP">Guadeloupe</option>
                      <option value="GU">Guam</option>
                      <option value="GT">Guatemala</option>
                      <option value="GG">Guernsey</option>
                      <option value="GN">Guinea</option>
                      <option value="GW">Guinea-Bissau</option>
                      <option value="GY">Guyana</option>
                      <option value="HT">Haiti</option>
                      <option value="HM">
                        Heard Island and Mcdonald Islands
                      </option>
                      <option value="VA">Holy See (Vatican City State)</option>
                      <option value="HN">Honduras</option>
                      <option value="HK">Hong Kong</option>
                      <option value="HU">Hungary</option>
                      <option value="IS">Iceland</option>
                      <option value="IN">India</option>
                      <option value="ID">Indonesia</option>
                      <option value="IR">Iran, Islamic Republic of</option>
                      <option value="IQ">Iraq</option>
                      <option value="IE">Ireland</option>
                      <option value="IM">Isle of Man</option>
                      <option value="IL">Israel</option>
                      <option value="IT">Italy</option>
                      <option value="JM">Jamaica</option>
                      <option value="JP">Japan</option>
                      <option value="JE">Jersey</option>
                      <option value="JO">Jordan</option>
                      <option value="KZ">Kazakhstan</option>
                      <option value="KE">Kenya</option>
                      <option value="KI">Kiribati</option>
                      <option value="KP">
                        Korea, Democratic People's Republic of
                      </option>
                      <option value="KR">Korea, Republic of</option>
                      <option value="XK">Kosovo</option>
                      <option value="KW">Kuwait</option>
                      <option value="KG">Kyrgyzstan</option>
                      <option value="LA">
                        Lao People's Democratic Republic
                      </option>
                      <option value="LV">Latvia</option>
                      <option value="LB">Lebanon</option>
                      <option value="LS">Lesotho</option>
                      <option value="LR">Liberia</option>
                      <option value="LY">Libyan Arab Jamahiriya</option>
                      <option value="LI">Liechtenstein</option>
                      <option value="LT">Lithuania</option>
                      <option value="LU">Luxembourg</option>
                      <option value="MO">Macao</option>
                      <option value="MK">
                        Macedonia, the Former Yugoslav Republic of
                      </option>
                      <option value="MG">Madagascar</option>
                      <option value="MW">Malawi</option>
                      <option value="MY">Malaysia</option>
                      <option value="MV">Maldives</option>
                      <option value="ML">Mali</option>
                      <option value="MT">Malta</option>
                      <option value="MH">Marshall Islands</option>
                      <option value="MQ">Martinique</option>
                      <option value="MR">Mauritania</option>
                      <option value="MU">Mauritius</option>
                      <option value="YT">Mayotte</option>
                      <option value="MX">Mexico</option>
                      <option value="FM">
                        Micronesia, Federated States of
                      </option>
                      <option value="MD">Moldova, Republic of</option>
                      <option value="MC">Monaco</option>
                      <option value="MN">Mongolia</option>
                      <option value="ME">Montenegro</option>
                      <option value="MS">Montserrat</option>
                      <option value="MA">Morocco</option>
                      <option value="MZ">Mozambique</option>
                      <option value="MM">Myanmar</option>
                      <option value="NA">Namibia</option>
                      <option value="NR">Nauru</option>
                      <option value="NP">Nepal</option>
                      <option value="NL">Netherlands</option>
                      <option value="AN">Netherlands Antilles</option>
                      <option value="NC">New Caledonia</option>
                      <option value="NZ">New Zealand</option>
                      <option value="NI">Nicaragua</option>
                      <option value="NE">Niger</option>
                      <option value="NG">Nigeria</option>
                      <option value="NU">Niue</option>
                      <option value="NF">Norfolk Island</option>
                      <option value="MP">Northern Mariana Islands</option>
                      <option value="NO">Norway</option>
                      <option value="OM">Oman</option>
                      <option value="PK">Pakistan</option>
                      <option value="PW">Palau</option>
                      <option value="PS">
                        Palestinian Territory, Occupied
                      </option>
                      <option value="PA">Panama</option>
                      <option value="PG">Papua New Guinea</option>
                      <option value="PY">Paraguay</option>
                      <option value="PE">Peru</option>
                      <option value="PH">Philippines</option>
                      <option value="PN">Pitcairn</option>
                      <option value="PL">Poland</option>
                      <option value="PT">Portugal</option>
                      <option value="PR">Puerto Rico</option>
                      <option value="QA">Qatar</option>
                      <option value="RE">Reunion</option>
                      <option value="RO">Romania</option>
                      <option value="RU">Russian Federation</option>
                      <option value="RW">Rwanda</option>
                      <option value="BL">Saint Barthelemy</option>
                      <option value="SH">Saint Helena</option>
                      <option value="KN">Saint Kitts and Nevis</option>
                      <option value="LC">Saint Lucia</option>
                      <option value="MF">Saint Martin</option>
                      <option value="PM">Saint Pierre and Miquelon</option>
                      <option value="VC">
                        Saint Vincent and the Grenadines
                      </option>
                      <option value="WS">Samoa</option>
                      <option value="SM">San Marino</option>
                      <option value="ST">Sao Tome and Principe</option>
                      <option value="SA">Saudi Arabia</option>
                      <option value="SN">Senegal</option>
                      <option value="RS">Serbia</option>
                      <option value="CS">Serbia and Montenegro</option>
                      <option value="SC">Seychelles</option>
                      <option value="SL">Sierra Leone</option>
                      <option value="SG">Singapore</option>
                      <option value="SX">Sint Maarten</option>
                      <option value="SK">Slovakia</option>
                      <option value="SI">Slovenia</option>
                      <option value="SB">Solomon Islands</option>
                      <option value="SO">Somalia</option>
                      <option value="ZA">South Africa</option>
                      <option value="GS">
                        South Georgia and the South Sandwich Islands
                      </option>
                      <option value="SS">South Sudan</option>
                      <option value="ES">Spain</option>
                      <option value="LK">Sri Lanka</option>
                      <option value="SD">Sudan</option>
                      <option value="SR">Suriname</option>
                      <option value="SJ">Svalbard and Jan Mayen</option>
                      <option value="SZ">Swaziland</option>
                      <option value="SE">Sweden</option>
                      <option value="CH">Switzerland</option>
                      <option value="SY">Syrian Arab Republic</option>
                      <option value="TW">Taiwan, Province of China</option>
                      <option value="TJ">Tajikistan</option>
                      <option value="TZ">Tanzania, United Republic of</option>
                      <option value="TH">Thailand</option>
                      <option value="TL">Timor-Leste</option>
                      <option value="TG">Togo</option>
                      <option value="TK">Tokelau</option>
                      <option value="TO">Tonga</option>
                      <option value="TT">Trinidad and Tobago</option>
                      <option value="TN">Tunisia</option>
                      <option value="TR">Turkey</option>
                      <option value="TM">Turkmenistan</option>
                      <option value="TC">Turks and Caicos Islands</option>
                      <option value="TV">Tuvalu</option>
                      <option value="UG">Uganda</option>
                      <option value="UA">Ukraine</option>
                      <option value="AE">United Arab Emirates</option>
                      <option value="GB">United Kingdom</option>
                      <option value="US">United States</option>
                      <option value="UM">
                        United States Minor Outlying Islands
                      </option>
                      <option value="UY">Uruguay</option>
                      <option value="UZ">Uzbekistan</option>
                      <option value="VU">Vanuatu</option>
                      <option value="VE">Venezuela</option>
                      <option value="VN">Viet Nam</option>
                      <option value="VG">Virgin Islands, British</option>
                      <option value="VI">Virgin Islands, U.s.</option>
                      <option value="WF">Wallis and Futuna</option>
                      <option value="EH">Western Sahara</option>
                      <option value="YE">Yemen</option>
                      <option value="ZM">Zambia</option>
                      <option value="ZW">Zimbabwe</option>
                    </select>
                  </div>
                </div>
                
                <button className="accountpopup_button" onClick={main}>
                {intl.formatMessage({id: "biilingButton"})}
                </button>
              </div>
            </div>
          </>
        )
      )}
      {OpenAccountpay && !OpenAccountPopUp && <Accountpay plan={plan} coupendata={coupendata} prev_subscription_id={prev_subscription_id} userId={userid}/>}
    </div>
  );
};
export default Accountpopup;
